import type { ReactNode } from "react";

import { Card } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { InfoTooltip } from "app/components/React/Tooltip/InfoTooltip/InfoTooltip";

import { MetricCardEmptyState } from "./MetricCardEmptyState";

const CARD_HEIGHT = "350px";

interface IMetricCardProps {
    title: string;
    infoText: string;
    dataAutomation: string;
    isLoading?: boolean;
    isEmpty?: boolean;
    loadingTemplate?: ReactNode;
    /** Card height. Defaults to a fixed height; pass "auto" to hug the content. */
    height?: string;
    /** i18n key for the empty-state title. Defaults to the Demand Analysis copy. */
    emptyStateTitleKey?: string;
    /** i18n key for the empty-state subtitle. Defaults to the Demand Analysis copy. */
    emptyStateSubtitleKey?: string;
    children: ReactNode;
}

export const MetricCard = ({
    title,
    infoText,
    dataAutomation,
    isLoading = false,
    isEmpty = false,
    loadingTemplate = null,
    height = CARD_HEIGHT,
    emptyStateTitleKey,
    emptyStateSubtitleKey,
    children,
}: IMetricCardProps) => (
    <Card
        flex="1"
        height={height}
        data-automation={dataAutomation}
    >
        <Card.Header withDivider>
            <Card.Title>
                <Flex
                    gap="8px"
                    alignItems="center"
                >
                    <Text fontVariant="h5_2">{title}</Text>
                    <InfoTooltip infoText={infoText} />
                </Flex>
            </Card.Title>
        </Card.Header>
        {isLoading ? (
            loadingTemplate
        ) : isEmpty ? (
            <MetricCardEmptyState
                titleKey={emptyStateTitleKey}
                subtitleKey={emptyStateSubtitleKey}
            />
        ) : (
            children
        )}
    </Card>
);
